import styles from './Page.module.css';
import React, { useState, useEffect } from 'react';

function CategoriesPage() {
  const [isSaving, setIsSaving] = useState(false);
  const [newsList, setNewsList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [documentsForBase, setDocumentsForBase] = useState([]);
  const [lastDocumentToBase, setLastDocumentToBase] = useState(0);

  useEffect(() => {
    async function getNews() {
      const response = await fetch('/api/reviews/forrevduplicatesnewslist');
      const data = await response.json();
      setNewsList(data.filter(item => item.categories));
      setDocumentsForBase(data.filter(item => item.categories));
    }
    getNews();
    async function getCategories() {
      const response = await fetch('/api/reviews/getcategoriesList', {
        method: 'POST'
      });
      const data = await response.json();
      setCategoriesList(data);
    }
    getCategories();
  }, []);


function handleCategoryClick(docIndex, currentCategory) {
  // create a copy of the clonedDocuments array
  const newClonedDocuments = [...documentsForBase];
  const categoryExists = newClonedDocuments[docIndex].categories.some(
    (category) => category === currentCategory.category
  );
  if (categoryExists) {
    // remove the similarity from the clonedDocuments array
    newClonedDocuments[docIndex].categories = newClonedDocuments[docIndex].categories.filter(
      (category) => category !== currentCategory.category
    );
  } else {
    // add the similarity to the clonedDocuments array
    newClonedDocuments[docIndex].categories.push(currentCategory.category);
  }

console.log(newClonedDocuments[docIndex].categories);

  // update the state with the new clonedDocuments array
  setDocumentsForBase(newClonedDocuments);
  if (docIndex > lastDocumentToBase) {
    setLastDocumentToBase(docIndex);
  }
}

const handleSave = async () => {
  setIsSaving(true);
  const reviewedNews = documentsForBase.slice(0, lastDocumentToBase+1);
  reviewedNews.forEach(function(item) {
    if (item.similarities.length) {
      item.stage = "not_publish_is_duplicate";
    } else {
      item.stage = "for_importance_review";
    }
  });
  if (reviewedNews.length > 0) {
    try {
      await  fetch('/api/reviews/duplicatesreviewednewstobase', {
        method: 'POST',
        body: JSON.stringify(reviewedNews),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        // Обробка відповіді сервера
      })
      .catch(error => {
        // Обробка помилки
      });
      setIsSaving(false);
      setLastDocumentToBase(0);
      const response = await fetch('/api/reviews/forrevduplicatesnewslist');
      const data = await response.json();
      const filteredNewsList = data.filter(item => item.similarities.length > 0);

      setNewsList(filteredNewsList);
      setDocumentsForBase(data.map((document) => ({ ...document, similarities: [document.similarities[0]] })));
    } catch (error) {
      console.error(error);
      setIsSaving(false);
    }

  }
  setIsSaving(false);
}; 

console.log(documentsForBase);

  return (
    <div className={styles.root}>
      <button onClick={handleSave} disabled={isSaving} style={{ position: "fixed", top: 0 }}>
        {isSaving ? "Saving..." : "Save similarity News"}
      </button>      
      {newsList.map((document, docIndex) => (
        <div key={document.id} className={styles.document}>
          <h2 className={styles.title}>{document.title}</h2>
            {categoriesList.map(category => (
                <button 
                key={category._id}
                // className={documentsForBase[docIndex].categories.some(
                //   (categoryOriginal) => categoryOriginal._id === category._id) ? styles.active : ""}
                className={documentsForBase[docIndex].categories.some(
                  (categoryOriginal) => categoryOriginal === category.category) ? styles.active : ""}

                onClick={() => handleCategoryClick(docIndex, category)}
                >
                  {category.category}
                </button>
            ))}
        </div>
      ))}
    </div>
  );
}

export default CategoriesPage;
